import { Lang } from 'Roblox';
import angular from 'angular';

const notificationStream = angular
  .module('notificationStream', ['robloxApp', 'ui.bootstrap', 'notificationStreamHtmlTemplate'])
  .config([
    'languageResourceProvider',
    function(languageResourceProvider) {
      if (Lang && Lang['Notifications.NotificationStream']) {
        languageResourceProvider.setLanguageKeysFromFile(Lang['Notifications.NotificationStream']);
      }
    }
  ]);

export default notificationStream;
